<template>
    <div id="batch-payment-list">
        <div class="container">
                    <h5 class="text-left mb-3">Batch Invoice</h5>

            <div class="datatable-form__header atr-header-wrap mb-4">
                <div class="datatable-form__input form-group flex-1">
                    <label>Academic Year</label>
                    <el-select placeholder="Search Academic Year" v-model="academicYearListSelected"
                               v-on:change="loadCourses()"  filterable>
                        <el-option
                                v-for="item in academicYearList"
                                :label="item.SMT_Code"
                                :value="item.PK_Semester_ID"
                        >
                        </el-option>
                    </el-select>
                </div>
                <div class="datatable-form__input form-group flex-1">
                    <label>Course</label>
                    <el-select placeholder="Select course" v-model="courseSelected"
                               v-on:change="loadClasses()"  filterable>
                        <el-option
                                v-for="item in courseList"
                                :label="item.CRS_Course_Name"
                                :value="item.PK_Course_ID"
                        >
                        </el-option>
                    </el-select>
                </div>
                <div class="datatable-form__input form-group flex-1">
                    <label>Class</label>
                    <el-select placeholder="Select Class" v-model="classesSelected"
                               filterable>
                        <el-option
                                v-for="item in classesList"
                                :label="item.CLS_ClassName+'-'+item.CLS_Batch"
                                :value="item.PK_Class_ID"
                        >
                        </el-option>
                    </el-select>
                </div>
            </div>

            <div class="datatable-form__header atr-header-wrap mb-4">

                <div class="datatable-form__input form-group flex-1">
                    <label>Term</label>
                    <el-select v-on:change="loadTerm('Yes')"
                               placeholder="Select Term" v-model="termSelected"
                               filterable>
                        <el-option
                                v-for="item in termList"
                                :label="item.SEMD_DetailName+'-'+item.SMT_Code"
                                :value="item.PK_SEMD_ID"
                        >
                        </el-option>
                    </el-select>
                </div>
                <div class="datatable-form__input">
                    <label>Select Date</label>
                    <el-date-picker
                            v-model="inputFromDate"
                            type="daterange"
                            range-separator="To"
                            :start-placeholder="fromDate"
                            :end-placeholder="toDate"
                            format="dd/MM/yyyy"
                            value-format="dd/MM/yyyy"
                    v-on:change="checkDatetimeValue()">
                    </el-date-picker>
                </div>
                <div class="datatable-form__submit text-center">
                    <button class="btn btn-success searchbtn" id="btnSearch" v-on:click="Search()">Search</button>
                </div>
            </div>

            <div class="admin-wrap">
                <div class="datatable-form__submit text-right">
                        <div class="col-lg-6" v-if="UnbilledBatchPaymentListInt.length>0">
                            <el-checkbox v-model="cbPrintMonthlyBreakdown" label="Print monthly breakdown" border
                                         class="float-left"></el-checkbox>
                        </div>

                    <el-button-group v-if="UnbilledBatchPaymentListInt.length>0">
                        <div class="datatable-form__input form-group flex-1">
                            <el-date-picker
                                    v-model="inputDueDate"
                                    type="date"
                                    format="dd/MM/yyyy"
                                    value-format="dd/MM/yyyy"
                                    placeholder="**Payment Due Date">
                            </el-date-picker>
                        </div>
                        <el-button type="primary" variant="primary" v-on:click="batchPreviewClick()">
                            Preview
                        </el-button>
                        <el-button type="primary" variant="primary" v-on:click="batchGenerateClick()">
                            Generate
                        </el-button><br><br>
                        <el-button v-on:click="btnUpdateBillingItemsAmount()" type="danger">
                            Update Group Items Amount
                        </el-button>
                    </el-button-group>
                </div>
                <br>
                <div class="pb-5">
                    <div class="empty-list_image"
                         v-if="UnbilledBatchPaymentListInt.length<1">
                        <strong>{{startupText}}</strong>
                        <img src="../assets/notfound.png"/>
                    </div>

                    <div v-if="negativeStudentListInt.length>0">
                        <b>Error List</b>
                        <data-tables :data="negativeStudentListInt"
                                     width="55" stripe tooltip-effect='light' border>
                            <el-table-column v-for="item in negativeStudentList"
                                             :prop="item.prop"
                                             :label="item.label"
                                             :key="item.prop"
                                             sortable="custom">
                            </el-table-column>
                        </data-tables>
                    </div>

                    <div v-if="UnbilledBatchPaymentListInt.length>0" class="datatable_group">
                        <div>
                            <el-input class="search-datatable" placeholder="Search Students/Billing Items"
                                      v-model="UnbilledBatchPaymentListFilters[0].value">
                                <template slot="prepend">
                                    <i class="material-icons">search</i>
                                    <span>Search Student/Billing Items</span>
                                </template>
                            </el-input>
                        </div>
                        <data-tables ref="selectableTable" :page-size="pageSize"
                                     :pagination-props="{ pageSizes: [pageSize,100] }"
                                     :filters="UnbilledBatchPaymentListFilters"
                                     :data="UnbilledBatchPaymentListInt" @selection-change="changeSelection"
                                     width="55" stripe tooltip-effect='light' border>
                            <el-table-column type="selection" width="55" :reserve-selection="true">
                            </el-table-column>
                            <el-table-column v-for="item in UnbilledBatchPaymentList"
                                             :prop="item.prop"
                                             :label="item.label"
                                             :key="item.prop"

                            >
                            </el-table-column>

                            <el-table-column v-if="isJPNSchool" label="GST" min-width="60px">
                                <template slot-scope="scope">
                                        <label type="number"
                                                  placeholder="GST">{{scope.row.newGSTAmount}}</label>
                                </template>
                            </el-table-column>
                            <el-table-column v-else label="GST" min-width="60px">
                                <template slot-scope="scope">
                                    <el-input v-model="scope.row.newGSTAmount" type="number"
                                              v-on:change="updateTotalClick(scope.row.newGSTAmount,scope.row.SPPD_PaymentAmount,scope.row)"
                                              :min="adjustmentMin(scope.row.SPPD_GstValue)"
                                              :max="adjustmentMax(scope.row.SPPD_GstValue)"
                                              :step="0.01" placeholder="GST"></el-input>
                                </template>
                            </el-table-column>

                            <el-table-column label="Total(IncludedGst)" min-width="70px">
                                <template slot-scope="scope">
                                        <el-input id="totalValueWithGst" v-model="scope.row.SPPD_TotalValue"
                                                  type="number" readonly="readonly"></el-input>
                                </template>
                            </el-table-column>
                            <el-table-column label="Rebate" min-width="50px">
                                <template slot-scope="scope">
                                    <div :class="{ test: scope.row.isRebate === 'Y' }">
                                        {{scope.row.isRebate}}
                                    </div>
                                </template>
                            </el-table-column>
                        </data-tables>
                        <el-button type="primary" variant="primary" v-on:click="clearSelect()">
                            Clear All Selection
                        </el-button>
                    </div>
                </div>
            </div>
        </div>

        <b-modal id="UpdateBillingItemsAmountModal" size="lg" title="Update Billing Items Amount" ok-only ok-variant="secondary"
                 hide-footer ref="showUpdateBillingItemsAmountModal">
            <div class="row ml-2 mr-2">
                <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12 mb3">
                    <label>*Billing Item Group</label>
                    <el-select v-model="selectedBillingItemGroup" class="fullwidth" @change="onChangeGetGstAmount()">
                        <el-option v-for="item in billingItemGroup" :value="item">
                            {{item}}
                        </el-option>
                    </el-select>
                    <div><label></label></div>
                </div>
                <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                    <label>*GST Amount</label>
                    <template v-if="isJPNSchool">
                        <input type="number" class="form-control" @keypress="onlyNumberJPN($event, selectedBillingItemAmount)"
                               v-model="selectedBillingItemAmount"
                          placeholder="GST"/>
                    </template>
                    <template v-else>
                        <el-input type="number" class="form-control" v-model="selectedBillingItemAmount"
                                  :min="groupAdjustmentMin(tempGstValue)"
                                  :max="groupAdjustmentMax(tempGstValue)"
                                  :step="0.01" placeholder="GST">
                        </el-input>
                    </template>

                </div>

                <hr class="custom-hr"/>
                <div class="col-lg-12">
                    <button v-on:click="UpdateItemsAmountClick()"
                            class="btn btn-primary waves-effect waves-light float-right">Update Amount
                    </button>
                </div>
            </div>
        </b-modal>

    </div>
</template>

<script>
    import DataSource from "../data/datasource";
    import Cookies from "js-cookie";
    import moment from 'moment';
    import GlobalFn from "../components/GlobalFn";

    export default {
        name: "BatchPaymentList",
        data(){
            return{
                fromDate:'',
                toDate:'',
                pageSize:100,
                readonly:true,
                spdSelection:[],
                arrobj_selectedSPD:[],
                datePicker:{
                    disabledDate(date){

                        return date<(new Date().getTime() - (1 * 24 * 60 * 60 * 1000));
                        //  Without using the second variable, you can replace 7 for with your back x days:
                        //e.g return date< Date(new Date().getTime() - (7 * 24 * 60 * 60 * 1000));
                    }
                },
                selectedData:[],
                academicYearListSelected:null,
                termSelected: '',
                academicYearList:[],
                academicYearListResponse:'',
                tempUnbillList:[],
                UnbilledBatchPaymentListInt:[],
                UnbilledBatchPaymentList:[{
                    prop: "StudentName",
                    label: "Student Name"
                }, {
                    prop: "Index_No",
                    label: "Student Number"
                }, {
                    prop: "SPPD_PayerName",
                    label: "Billing Items"
                },{
                    prop: "SPPD_PaymentAmount",
                    label: "Amount"
                }],
                UnbilledBatchPaymentListFilters:[
                    {
                        value: '',
                        prop: ['StudentName', 'SPPD_PayerName']
                    },
                ],
                inputDueDate:'',
                courseListResponse:'',
                courseList:[],
                termList:[],

                //Class items
                classesSelected:'',
                classesList:[],
                classesListResponse:[],
                //class Item

                //start:update
                courseSelected:'',
                courseID:'',
                semesterID:'',
                schoolID:'',
                //
                inputFromDate:[],
                startupText:'',

                schoolsList:[],
                allSchoolsList:[],
                schoolsListResponse:[],

                schoolListInt:[],
                previewResultList:'',

                //breakdown items
                cbPrintMonthlyBreakdown:false,
                breakdownFlag:'',
                objNonCourseFees:[],
                nonEligibleStudentList:[],
                //breakdown items

                negativeStudentListInt:[],
                negativeStudentList:[{
                    prop: "StudentName",
                    label: "Student Name"
                }, {
                    prop: "Index_No",
                    label: "Index NO"
                }, {
                    prop: "NegativeAmount",
                    label: "Negative Amount"
                }],
                rebateStudentListInt:[],
                rebateStudentList:[{
                    prop: "StudentName",
                    label: "Student Name"
                }, {
                    prop: "Index_No",
                    label: "Index NO"
                }, {
                    prop: "NegativeAmount",
                    label: "Negative Amount"
                },{
                    prop: "Remark",
                    label: "Remark"
                }],
                billingItemGroup:[],
                selectedBillingItemGroup:'',
                selectedBillingItemAmount:'',
                selectedBillingAmount:'',

                tempGstValue:'',
                isJPNSchool : false,
            }
        },
        async mounted(){
            this.schoolID = Cookies.get('schoolSession');
            await this.checkJPNSchool();
            await this.BindAcademicYear();
        },
        async created(){
        },

        methods:{
            highlightRebateItem({row, rowIndex}) {
               // console.log(rowIndex, 'a');
                if (row.isRebate === 'N') {
                   // console.log(rowIndex, 'b');
                    return 'test no-hover'
                } else {
                    return '';
                }
            },
            checkDatetimeValue(){
                console.log('inputFromDate',this.inputFromDate,this.inputFromDate[0],this.inputFromDate[1]);
            },
            getCurrentDate(){
                var currentDate =new Date();
                this.inputDueDate=currentDate;
            },

            displayPdf(base64string) {
                var byteChar = atob(base64string);
                var byteNo = new Array(byteChar.length);
                for (var i = 0; i < byteChar.length; i++) {
                    byteNo[i] = byteChar.charCodeAt(i);
                }

                var byteArray = new Uint8Array(byteNo);
                var file = new Blob([byteArray], {type: 'application/pdf;base64'});
                var fileUrl = URL.createObjectURL(file);
                // window.openBrowser(fileUrl);
                window.open(fileUrl, '_blank', 'width=500, height=500');
            },

            async checkBatchPaymentBreakdownEligible(){
                    var eligible = true;
                    let courseFeesCount = 0;
                    this.nonEligibleStudentList=[];
                    this.arrobj_selectedSPD.forEach(m=>{
                        let stuName='';
                        let nonCourseFeesCount = 0;
                                m.ArrObj_Items.forEach(n=>{
                                    if(n.PPD_CalCategory==="Course Fees")
                                    {
                                        courseFeesCount++;
                                    }
                                    else
                                    {
                                        nonCourseFeesCount++;
                                        stuName=n.StudentName;
                                    }
                                });
                        if(m.ArrObj_Items.length==nonCourseFeesCount){
                            this.nonEligibleStudentList.push(stuName);
                            eligible = false;
                        }

                    });

                return eligible;
            },

            async batchPreviewClick(){
                try{
                    this.sortByStudentNO();
                    //todo:check eligibility for negative items and value: start
                    let countNegativeStudent = 0;
                    let tempListObj=[];
                    let countRebateStudent = 0;
                    let countRebateValue = 0;
                    this.arrobj_selectedSPD.forEach(m=>{
                        let countNegativeItem = 0;
                        let countValue = 0;
                        let studentName = '';
                        let countRebateItem = 0;
                        let TotalValue = 0;
                       m.ArrObj_Items.forEach(n=>{
                           if(parseFloat(n.SPPD_TotalValue)<0&&n.isRebate==='N')
                           {
                               countNegativeItem++;
                               TotalValue = n.SPPD_TotalValue;
                           }
                           else if(n.isRebate==='Y')
                           {
                               countRebateItem++;
                               TotalValue = -(n.SPPD_TotalValue);
                           }
                           else{
                               TotalValue = n.SPPD_TotalValue;
                           }
                           countValue+=parseFloat(TotalValue);
                           studentName = n.Full_Name+' '+n.Last_name;
                       });
                       console.log('countRebateItem',countRebateItem,'countValue=',countValue);

                       if(parseFloat(countNegativeItem)>0 && parseFloat(countValue)<0)
                       {
                            countNegativeStudent++;
                               let tempList = {
                                   StudentName:studentName,
                                   Index_No:m.ArrObj_Items[0].Index_No,
                                   NegativeAmount:parseFloat(countValue).toFixed(2),
                               };
                               tempListObj.push(tempList);
                               this.negativeStudentListInt = tempListObj;
                       }
                       else if(parseFloat(countValue)<0&&parseInt(countRebateItem)>0)
                        {
                            countRebateStudent++;
                            countRebateValue+=countValue;
                            console.log('countRebateStudent=',countRebateStudent);
                            let tempList = {
                                StudentName:studentName,
                                Index_No:m.ArrObj_Items[0].Index_No,
                                NegativeAmount:parseFloat(countValue).toFixed(2),
                                Remark: 'Rebate',
                            };
                            tempListObj.push(tempList);
                            this.rebateStudentListInt = tempListObj;
                        }

                    });
                    //todo:To check eligibility for negative items and value: end

                    if (!this.inputDueDate)
                    {
                        this.$notify({
                            title: 'Require',
                            message: '"Payment Due Date"'
                        });
                    }
                    else if(this.spdSelection.length === 0) {
                        this.$notify.error({
                            title: 'Error',
                            message: 'Please select at least 1 payment item'
                        });
                    }
                    else if(countRebateStudent>0&&countRebateValue<0)
                    {
                        this.$notify({
                            title: 'Error',
                            message: '"Cannot generate invoice,the rebate/refund items are larger than line items."'
                        });
                    }
                    else if(countNegativeStudent>0){
                        this.$notify({
                            title: 'Error',
                            message: '"Cannot generate invoice with negative value, please check students below:"'
                        });
                    }
                    else{
                        //check breakdown
                        if(this.cbPrintMonthlyBreakdown){
                             var breakdownflag = await this.checkBatchPaymentBreakdownEligible();
                            if(breakdownflag==true)
                            {
                                this.breakdownFlag='Y';
                                await this.batchPreview();
                            }
                            else
                            {
                                let nonEligibleStudentListString="";
                                this.nonEligibleStudentList.forEach(n=>{
                                    nonEligibleStudentListString+=(n+', ');
                                });
                                let nonEligibleStudent= nonEligibleStudentListString.trim().substring(0,nonEligibleStudentListString.trim().length-1);
                                this.breakdownFlag='N';
                                this.$notify.error({
                                    title: 'Message',
                                    message: 'Below students are not eligible for breakdown! (no course fees type found)'+nonEligibleStudent,
                                });
                            }
                        }
                        else
                        {
                            this.breakdownFlag='N';
                            await this.batchPreview();
                        }
                        //check breakdown
                    }
                }
                catch (e) {
                    this.results = e;
                }

            },

            async batchPreview(){
                try{
                    let actionType = 'Preview';
                    let List = [];
                    let batchPaymentObj = {};
                    this.arrobj_selectedSPD.forEach(m=>{
                        let objList=[];
                        m.ArrObj_Items.forEach(n=>{
                                    let isRebateItem = 'N', InvoiceDetailID = '', InvoiceID = '';
                                    if(n.isRebate==='Y'){isRebateItem='Y';
                                        InvoiceDetailID = n.PK_Invoice_Detail_ID;
                                        InvoiceID= n.PK_Invoice_ID; }
                                    else{isRebateItem = 'N';
                                        InvoiceDetailID = n.PK_Invoice_Detail_ID;
                                        InvoiceID= n.PK_Invoice_ID; }
                            List = {
                                studentCourseID:n.PK_Student_Course_ID,
                                PK_SPD_ID:n.PK_SPD_ID,
                                SPPD_PayerName:n.SPPD_PayerName,
                                SPPD_PaymentItemType:n.SPPD_PaymentItemType,
                                SPPD_PaymentAmount:n.SPPD_PaymentAmount,
                                SPPD_GstValue:n.newGSTAmount,
                                isRebate: isRebateItem,
                                PK_Invoice_Detail_ID: InvoiceDetailID,
                                PK_Invoice_ID: InvoiceID,
                            };
                            objList.push(List);
                        });

                        batchPaymentObj["studentID_"+m.Str_SortBy] = objList;

                    });

                    this.$vs.loading();
                    const resp = await DataSource.shared.generateBatchInvoice(JSON.stringify(batchPaymentObj),this.inputDueDate,
                        actionType,this.breakdownFlag);
                    if (resp) {
                        if (resp.code === '88') {
                            window.location.replace('/');
                        } else if (resp.code === '99') {
                            this.$notify.error({
                                title: 'Error',
                                message: 'Cannot preview batch invoice!'
                            });
                        } else if (resp.code === '2') {
                            this.$notify({
                                title: 'No Record',
                                message: 'No Record Found'
                            });
                        } else
                        {
                            this.arrobj_selectedSPD=[];
                            this.displayPdf(resp.code);
                        }
                    }
                }
                catch (e) {
                    this.results = e;
                }
                this.$vs.loading.close();
            },

            async batchGenerateClick(){
                try{
                    this.sortByStudentNO();
                    let countNegativeStudent = 0;
                    let tempListObj=[];

                    this.arrobj_selectedSPD.forEach(m=>{
                        let countNegativeItem = 0;
                        let countValue = 0;
                        let studentName = '';

                        m.ArrObj_Items.forEach(n=>{
                            if(parseFloat(n.SPPD_TotalValue)<0)
                            {
                                countNegativeItem++;
                            }
                            countValue+=parseFloat(n.SPPD_TotalValue);
                            // countValue = countValue+parseFloat(n.SPPD_TotalValue);
                            studentName = n.Full_Name+' '+n.Last_name;
                        });

                        if(parseFloat(countNegativeItem)>0 && parseFloat(countValue)<0)
                        {
                            countNegativeStudent++;
                            let tempList = {
                                StudentName:studentName,
                                Index_No:m.ArrObj_Items[0].Index_No,
                                NegativeAmount:parseFloat(countValue).toFixed(2),
                            };
                            tempListObj.push(tempList);
                            this.negativeStudentListInt = tempListObj;
                        }

                    });

                    if (!this.inputDueDate)
                    {
                        this.$notify.error({
                            title: 'Require',
                            message: '"Payment Due Date"'
                        });
                    }
                    else if(this.spdSelection.length === 0) {
                        this.$notify.error({
                            title: 'Error',
                            message: 'Please select at least 1 payment item'
                        });
                    }
                    else if(countNegativeStudent>0){
                        this.$notify({
                            title: 'Error',
                            message: '"Cannot generate invoice with negative value, please check students below:"'
                        });
                    }
                    else{
                        //call batchGenerate method,
                        //check breakdown
                        if(this.cbPrintMonthlyBreakdown){
                            var breakdownflag = await this.checkBatchPaymentBreakdownEligible();
                            if(breakdownflag==true)
                            {
                                this.breakdownFlag='Y';
                                await this.batchGenerate();
                            }
                            else
                            {
                                let nonEligibleStudentListString="";
                                this.nonEligibleStudentList.forEach(n=>{
                                    nonEligibleStudentListString+=(n+', ');
                                });
                                let nonEligibleStudent= nonEligibleStudentListString.trim().substring(0,nonEligibleStudentListString.trim().length-1);
                                this.breakdownFlag='N';
                                this.$notify.error({
                                    title: 'Message',
                                    message: 'Below students are not eligible for breakdown! (no course fees type found)'+nonEligibleStudent,
                                });
                            }
                        }
                        else
                        {
                            this.breakdownFlag='N';
                            await this.batchGenerate();
                        }
                        //check breakdown

                    }

                }
                catch (e) {
                    this.results = e;
                }
            },

            async batchGenerate(){
                try{
                    this.$vs.loading();
                    let actionType = 'Generate';
                    let List = [];
                    let batchPaymentObj = {};
                    this.arrobj_selectedSPD.forEach(m=>{
                        let objList=[];
                        m.ArrObj_Items.forEach(n=>{
                            let isRebateItem = 'N', InvoiceDetailID = '', InvoiceID = '';
                            if(n.isRebate==='Y'){isRebateItem='Y';
                                InvoiceDetailID = n.PK_Invoice_Detail_ID;
                                InvoiceID= n.PK_Invoice_ID;}
                            else{isRebateItem = 'N';
                                InvoiceDetailID = n.PK_Invoice_Detail_ID;
                                InvoiceID= n.PK_Invoice_ID; }

                            List = {
                                studentCourseID:n.PK_Student_Course_ID,
                                PK_SPD_ID:n.PK_SPD_ID,
                                SPPD_PayerName:n.SPPD_PayerName,
                                SPPD_PaymentItemType:n.SPPD_PaymentItemType,
                                SPPD_PaymentAmount:n.SPPD_PaymentAmount,
                                SPPD_GstValue:n.newGSTAmount,
                                isRebate: isRebateItem,
                                PK_Invoice_Detail_ID: InvoiceDetailID,
                                PK_Invoice_ID: InvoiceID,
                            };
                            objList.push(List);
                        });

                        batchPaymentObj["studentID_"+m.Str_SortBy] = objList;
                    });

                    const resp = await DataSource.shared.generateBatchInvoice(JSON.stringify(batchPaymentObj),this.inputDueDate,actionType,this.breakdownFlag);
                    if (resp) {
                        if (resp.code === '88') {
                            window.location.replace('/');
                        } else if (resp.code === '99') {
                            this.$notify.error({
                                title: 'Error',
                                message: 'Cannot generate batch invoice!'
                            });
                        } else if (resp.code === '2') {
                            this.$notify({
                                title: 'No Record',
                                message: 'No Record Found'
                            });
                        } else
                        {
                            batchPaymentObj={};
                            this.arrobj_selectedSPD=[];
                            this.displayPdf(resp.code);
                            this.Search();
                        }
                    }
                }
                catch (e) {
                    this.results = e;
                }
                this.$vs.loading.close();
            },

            clearSelect () {
                // this.spdSelection=null;
            },

            getRowKeys(row){
                return row.PK_SPD_ID;
            },

            async changeSelection(val) {
                this.spdSelection=val;
            },

            adjustmentMin(value){
                return (parseFloat(value)-parseFloat(0.01));
            },

            adjustmentMax(value){
                return (parseFloat(value)+parseFloat(0.01));
            },

            groupAdjustmentMin(value){
                let MinValue = 0;
                MinValue = (parseFloat(value).toFixed(2)-parseFloat(0.01));
                return parseFloat(MinValue.toFixed(2));
            },

            groupAdjustmentMax(value){
                let MaxValue = 0;
                MaxValue = parseFloat(value)+parseFloat(0.01)
                return parseFloat(MaxValue.toFixed(2));
            },

            updateTotalClick(gstValue,currentAmount,rowData){

                let gst = parseFloat(gstValue);
                let amount = parseFloat(currentAmount);
                let total = 0.0;

                total = gst +amount;

                this.UnbilledBatchPaymentListInt.forEach(m => {

                    if(m.PK_SPD_ID==rowData.PK_SPD_ID)
                    {
                        m.SPPD_TotalValue = total.toFixed(2);
                    }
                });
            },

            async BindAcademicYear(){
                try{
                    this.academicYearList=[];
                    if(this.schoolID.length>0){
                        const response = await DataSource.shared.getAcademicYearBySchoolID(this.schoolID);
                        this.academicYearListResponse=response.Table;
                        this.academicYearListResponse.forEach(m => {
                            this.academicYearList.push(m);
                        });

                        this.academicYearListResponse=[];
                        //todo: to refesh academic year, course and class list
                        await this.loadCourses();
                    }
                }
                catch (e) {
                    this.results = e;
                }
            },

            async loadCourses(){
                try{
                    this.courseList = [];
                    this.classesList = [];
                    this.semesterID = this.academicYearListSelected;
                    let coursePList =[];
                    if(this.schoolID.length>0){
                        const response = await DataSource.shared.getCourseBySemesterID(this.schoolID,this.semesterID);
                        this.courseListResponse=response.Table;
                        this.courseListResponse.forEach(m => {
                            coursePList.push(m);
                        });
                        this.courseList=coursePList;
                        this.courseListResponse=[];
                    }
                    if(this.academicYearListSelected)
                    {
                        await this.loadTerm();
                    }
                }
                catch (e) {
                    this.results = e;
                }
            },

            async loadClasses(){
                try{
                    if(this.schoolID.length>0){
                        let classesPList =[];
                        const response = await DataSource.shared.getClassBySemesterAndCourseID(this.semesterID,this.courseSelected);
                        this.classesListResponse=response.Table;
                        this.classesListResponse.forEach(m => {
                            classesPList.push(m);
                        });
                        this.classesList = classesPList;
                        this.classesListResponse=[];
                    }
                }
                catch (e) {
                    this.results = e;
                }
            },

            async loadTerm(value){
                try{
                    if(this.academicYearListSelected){
                        let termPList =[];
                        if(value=='Yes'){
                            const response = await DataSource.shared.getSemesterTermDetailsBySemDetailID('',this.termSelected,'');
                            this.termListResponse=response.Table;
                            this.termListResponse.forEach(m => {

                                this.inputFromDate[0] = m.SEMD_FromDate;
                                this.inputFromDate[1] = m.SEMD_ToDate;

                                this.fromDate = m.SEMD_FromDate_Convert;
                                this.toDate = m.SEMD_ToDate_Convert;

                                termPList.push(m);
                            });
                            //todo to update select time
                            this.termListResponse=[];
                        }
                        else{
                            this.termList = [];
                            const response = await DataSource.shared.getSemesterTermDetailsBySemID(this.semesterID,'','Active');
                            this.termListResponse=response.Table;
                            this.termListResponse.forEach(m => {
                                termPList.push(m);
                            });
                            this.termList = termPList;
                            this.termListResponse=[];
                        }
                    }
                }
                catch (e) {
                    this.results = e;
                }
            },

            async Search() {
                try {
                    this.startupText = "No Data Found...";
                    this.UnbilledBatchPaymentListInt =[];
                    this.negativeStudentListInt=[];
                    if (!this.schoolID)
                    {
                        this.$notify({
                            title: 'Require',
                            message: '"No assigned school"'
                        });
                    }
                    else if(!this.semesterID)
                    {
                        this.$notify({
                            title: 'Require',
                            message: '"Please select academic year"'
                        });
                    }
                    else if(!this.courseSelected)
                    {
                        this.$notify({
                            title: 'Require',
                            message: '"Please select course"'
                        });
                    }
                    else
                        {
                            this.$vs.loading();
                            let courseID='';
                            let classID ='';
                            if(this.courseSelected){
                                courseID = this.courseSelected;
                                classID = this.classesSelected;
                            }
                            else{
                                courseID = '';
                                classID = '';
                            }

                            const response = await DataSource.shared.getUnbilledBatchPaymentList(this.schoolID, this.semesterID,
                                courseID,classID,this.inputFromDate[0],this.inputFromDate[1]);

                        if (response) {
                            if (response.code === '88') {
                                window.location.replace('/');
                            } else if (response.code === '99') {
                                this.$notify.error({
                                    title: 'Error',
                                    message: 'Error 99!'
                                });
                            } else if (response.code === '2') {
                                this.$notify({
                                    title: 'No Record',
                                    message: 'No Record Found'
                                });
                            } else
                                {
                                    this.tempUnbillList = response.Table;
                                    let tempList = [];
                                    this.tempUnbillList.forEach(m=>{
                                        m.newGSTAmount=m.SPPD_GstValue;
                                        tempList.push(m);
                                    })
                                    this.spdSelection=[];
                                    this.UnbilledBatchPaymentListInt = tempList;
                                    //this.UnbilledBatchPaymentListInt = GlobalFn.SortObjectByKey(tempList, 'Index_No', 'asc'); //do not need to sort here as backend already sort by name
                                    // console.log('this.UnbilledBatchPaymentListInt=',this.UnbilledBatchPaymentListInt);
                                }
                        }

                    }
                } catch (e) {
                    this.results = e;
                }
                this.$vs.loading.close();
            },

            onlyNumber($event) {
                let keyCode = ($event.keyCode ? $event.keyCode : $event.which);
                // Allow the minus sign (-) if the user enters it first
                if (keyCode === 45 && (this.inputAddItemAmount === '' || this.inputAddItemAmount === null)) { // code 45 is "-"
                    return;
                } else if (keyCode === 46 && !this.inputAddItemAmount.includes('.') && this.inputAddItemAmount !== '') { // code 46 is "."
                    if (this.inputAddItemAmount.includes('-') && this.inputAddItemAmount.length === 1) {
                        $event.preventDefault();
                    } else {
                        return;
                    }
                } else if (keyCode < 48 || keyCode > 57){
                    $event.preventDefault();
                }
            },

            sortByStudentNO() {
                    let sortedList = this.groupBy(this.spdSelection, "Student_ID");
                    this.arrobj_selectedSPD = sortedList;
            },

            groupBy(data, key) {

                let ArrObj_Sorted = [];

                for (let item of data) {
                    let index = ArrObj_Sorted.findIndex(x => x.Str_SortBy === item[key]);

                    if (index === -1) {
                        ArrObj_Sorted.push({Str_SortBy: item[key], ArrObj_Items: [item]});
                    } else
                        ArrObj_Sorted[index].ArrObj_Items.push(item);
                }

                return ArrObj_Sorted;
            },

            onChangeGSTclick(gstValue){

                let gst = parseFloat(gstValue);
                let amount = parseFloat(this.selectedBillingAmount);
                let total = 0.0;

                total = gst +amount;

                return parseFloat(total.toFixed(2));
            },
            onChangeGetGstAmount(){
                let tempGst = 0;
                this.UnbilledBatchPaymentListInt.forEach(n=>{
                    if(this.selectedBillingItemGroup === n.SPPD_PayerName){
                        this.selectedBillingItemAmount = parseFloat(n.newGSTAmount);
                        tempGst = this.selectedBillingItemAmount;
                        this.selectedBillingAmount = parseFloat(n.SPPD_PaymentAmount);
                    }
                });
                this.tempGstValue = tempGst;
            },
            btnUpdateBillingItemsAmount(){
                try{
                    this.billingItemGroup = [];
                    this.UnbilledBatchPaymentListInt.forEach(n=>{
                        if(!n.SPPD_PayerName){
                            console.log('undefined value!!')
                        }
                        else{
                            if(!this.billingItemGroup.includes(n.SPPD_PayerName)){
                                this.billingItemGroup.push(n.SPPD_PayerName);
                            }
                        }
                    });
                    this.$refs.showUpdateBillingItemsAmountModal.show();
                /*
                 billingItemGroup:[],
                selectedBillingItemGroup:"",
                selectedBillingItemAmount:""
                *
                */
                }
                catch (e) {
                    this.results = e;
                }
            },
            UpdateItemsAmountClick()
            {
                try{
                        this.UnbilledBatchPaymentListInt = this.UnbilledBatchPaymentListInt.map(m=> {

                            if (m.SPPD_PayerName == this.selectedBillingItemGroup) {
                                m.newGSTAmount = this.selectedBillingItemAmount;
                                let gst = parseFloat(m.newGSTAmount);
                                let amount = parseFloat(m.SPPD_PaymentAmount);

                                m.SPPD_TotalValue = gst +amount;
                            }
                            return m;
                        });

                    this.$refs.showUpdateBillingItemsAmountModal.hide();
                }
                catch (e) {
                this.results = e;
                }
            },

            async checkJPNSchool(){
                try
                {
                    const resp = await DataSource.shared.getSchoolInfoBySchoolID(Cookies.get('schoolSession'));
                    console.log('JPN SCHOOL',resp.Table);
                    if(resp){
                        if(resp.code==='99'){

                        }
                        else if(resp.code==='88')
                        {

                        }
                        else{
                            //a==0 ? "zero" : "not zero"
                            resp.Table[0].SCH_Country==='Japan' ? this.isJPNSchool= true : this.isJPNSchool= false;
                            console.log('this.isJPNSchool',this.isJPNSchool);
                        }
                    }
                }
                catch(e)
                {
                    this.results = e;
                }
            },
            onlyNumberJPN($event, inputValue) {
                let keyCode = ($event.keyCode ? $event.keyCode : $event.which);
                // Allow the minus sign (-) if the user enters it first
                if (keyCode === 45 &&(inputValue === '' || inputValue === null)) { // code 45 is "-"
                    return;
                } else if (keyCode === 46 && !inputValue.includes('.') && inputValue !== '') { // code 46 is "."
                    if (inputValue.includes('-') && inputValue.length === 1) {
                        $event.preventDefault();
                    }
                    else if(keyCode === 46 ){
                        $event.preventDefault();
                    }
                    else {
                        return;
                    }
                } else if (keyCode < 48 || keyCode > 57){
                    $event.preventDefault();
                }
            },
        },
    }
</script>

<style scoped>
    .datatable-form__header .searchbtn {
        background: #4856ad;
        border-color: #4856ad;
        height: 37px;
        position: relative;
        top: 1px;
    }
</style>
<style>
    #totalValueWithGst{border:0px solid}

    .test {
        background-color: yellow !important;
        padding: 10px;
    }

    /*.no-hover:hover > td {*/
    /*    background-color: initial !important;*/
    /*}*/

    /*.el-table--disabled-row-hover .el-table__body tr:hover>td{*/
    /*    background-color: #212e3e !important;*/
    /*}*/
    /*.hover-row > td {*/
    /*    background-color: initial !important;*/
    /*}*/
    .el-table--body tr:hover >td{
        background-color: red  !important;
    }

</style>

